export const environment = {
  name: 'test',
  environment: "test",
  production: true,
  msalEnable: true
};
